import React from 'react';
import RolloutStatusBadge from './RolloutStatusBadge';
import { toPercent } from '../lib/recoveryRolloutFormatters';

const Metric = ({ label, value }) => (
  <div className="rounded-lg border border-slate-800 bg-slate-950/70 px-3 py-2">
    <p className="text-[11px] uppercase tracking-wide text-slate-500">{label}</p>
    <p className="mt-1 text-sm font-semibold text-slate-100">{value}</p>
  </div>
);

const RecoveryReadinessPanel = ({ readiness }) => {
  const metrics = readiness?.summaryMetrics || {};

  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <div className="mb-3 flex items-center justify-between gap-2">
        <h3 className="text-sm font-semibold text-slate-100">Readiness Summary</h3>
        <RolloutStatusBadge status={readiness?.readinessStatus || 'BLOCKED'} />
      </div>

      <div className="grid gap-2 sm:grid-cols-2 xl:grid-cols-4">
        <Metric label="Total Comparisons" value={metrics.totalComparisons ?? 0} />
        <Metric label="Match Rate" value={toPercent(metrics.sameActionRate)} />
        <Metric label="Fallback Rate" value={toPercent(metrics.fallbackRate)} />
        <Metric label="V2 Error Rate" value={toPercent(metrics.v2ErrorRate)} />
        <Metric label="Retry Intent Rate" value={toPercent(metrics.sameRetryIntentRate)} />
        <Metric label="Escalation Intent Rate" value={toPercent(metrics.sameEscalationIntentRate)} />
        <Metric label="Expected Divergence" value={toPercent(metrics.expectedDivergenceRate)} />
        <Metric label="Stability Window" value={`${metrics.stabilityWindowHours ?? 0} jam`} />
      </div>
    </section>
  );
};

export default RecoveryReadinessPanel;
